<template>
    <b-row v-if="!isLoading && questionnaires.length" class="mt-4">
        <section-slot
            sectionIcon="fas fa-clipboard-list"
            :section="$t('values.spontaneousEvaluation')"
        >
            <div class="font-weight-bold text-muted text-uppercase">
                <small>{{ $t('profile.clickToEvaluate') }}</small>
            </div>
            <div>
                <div
                    :key="index"
                    v-for="(questionnaire, index) in questionnaires"
                >
                    <h6 class="text-muted">{{ questionnaire.title }}</h6>
                    <div class="d-flex flex-row flex-wrap mb-1">
                        <div
                            :key="index"
                            class="mr-1 mb-1"
                            v-for="(value, index) in questionnaire.values"
                            :id="`btn-talk-spontaneous-evaluation-value-${value.id}`"
                        >
                            <b-link
                                :id="`avatar-${value.id}-${questionnaire.id}`"
                                :to="`/v2/profile/${evaluated.id}/spontaneous-evaluation?questionnaireId=${questionnaire.id}&valueId=${value.id}`"
                            >
                                <avatar
                                    :size="35"
                                    :src="value.picture"
                                    :username="value.title"
                                />
                            </b-link>
                            <b-tooltip
                                :target="`avatar-${value.id}-${questionnaire.id}`"
                                placement="top"
                            >
                                {{ value.title }}
                            </b-tooltip>
                        </div>
                    </div>
                </div>
            </div>
        </section-slot>
    </b-row>
</template>
<script>
import Avatar from 'vue-avatar'
import SectionSlot from '../section-slot'
import getAvaliablesQuestionnairesToEvaluate from './api'

export default {
    components: {
        Avatar,
        SectionSlot,
    },
    props: {
        evaluated: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isLoading: true,
            questionnaires: [],
        }
    },
    mounted() {
        this.getQuestionnaires()
    },
    methods: {
        getQuestionnaires() {
            this.isLoading = true
            getAvaliablesQuestionnairesToEvaluate(this.evaluated.id)
                .then((questionnaires) => {
                    this.questionnaires = questionnaires
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
    },
    watch: {
        evaluated(newUser, oldUser) {
            if (newUser != oldUser) {
                this.getQuestionnaires()
            }
        },
    },
}
</script>
